/**
 * @packageDocumentation
 * @module api.functional.admin.companies.bulk
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { CreateCompanyDto } from "../../../../structures/CreateCompanyDto";
import type { ServiceResponseArrayCreatedCompanyDto } from "../../../../structures/ServiceResponseArrayCreatedCompanyDto";

/**
 * @controller CompanyController.createCompaniesBulk
 * @path POST /admin/companies/bulk
 * @accessor api.functional.admin.companies.bulk.createCompaniesBulk
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function createCompaniesBulk(
  connection: IConnection,
  body: createCompaniesBulk.Body,
): Promise<createCompaniesBulk.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...createCompaniesBulk.METADATA,
      template: createCompaniesBulk.METADATA.path,
      path: createCompaniesBulk.path(),
    },
    body,
  );
}
export namespace createCompaniesBulk {
  export type Body = CreateCompanyDto[];
  export type Output = ServiceResponseArrayCreatedCompanyDto;

  export const METADATA = {
    method: "POST",
    path: "/admin/companies/bulk",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/admin/companies/bulk";
}
